import { PATH, TITLES } from '@repo/constants';
import {
  BriefcaseConveyorBeltIcon,
  ConstructionIcon,
  FileIcon,
  FilePlusIcon,
  FileSearchIcon,
  FolderIcon,
  FolderKanbanIcon,
  GroupIcon,
  ListCheckIcon,
  ListIcon,
  ListOrderedIcon,
  LogsIcon,
  MessageCircleWarningIcon,
  PocketKnifeIcon,
  ProportionsIcon,
  RefreshCcwIcon,
  SettingsIcon,
  UserPenIcon,
  UsersIcon,
  WrenchIcon,
} from 'lucide-react';

export const getNavItemsAdmin = () => {
  return [
    {
      id: 'user-management',
      icon: UserPenIcon,
      label: 'User Management',
      children: [
        {
          id: 'user-management-users',
          icon: UsersIcon,
          label: TITLES.USER_MANAGEMENT_USERS,
          allowed: true,
          path: PATH.USER_MANAGEMENT_USERS,
        },

        {
          id: 'user-management-permissions',
          icon: ProportionsIcon,
          label: TITLES.USER_MANAGEMENT_PERMISSIONS,
          allowed: true,
          path: PATH.USER_MANAGEMENT_PERMISSIONS,
        },
        {
          id: 'user-management-groups',
          icon: GroupIcon,
          label: TITLES.USER_MANAGEMENT_GROUPS,
          allowed: true,
          path: PATH.USER_MANAGEMENT_GROUPS,
        },
      ],
    },
    {
      id: 'configuration',
      icon: WrenchIcon,
      label: 'Configuration',
      children: [
        {
          id: PATH.CONFIGURATION_PARAMETER,
          label: TITLES.CONFIGURATION_PARAMETER,
          path: PATH.CONFIGURATION_PARAMETER,
          allowed: true,
          icon: ListIcon,
        },
        {
          id: PATH.CONFIGURATION_PARAMETER_VALUE_ID,
          label: TITLES.CONFIGURATION_PARAMETER_VALUE_ID,
          path: PATH.CONFIGURATION_PARAMETER_VALUE_ID,
          allowed: true,
          icon: ListOrderedIcon,
        },
        {
          id: PATH.CONFIGURATION_SETTLEMENT_CYCLES,
          label: TITLES.CONFIGURATION_SETTLEMENT_CYCLES,
          path: PATH.CONFIGURATION_SETTLEMENT_CYCLES,
          allowed: true,
          icon: RefreshCcwIcon,
        },
      ],
    },
    {
      id: 'tools',
      icon: PocketKnifeIcon,
      label: 'Tools',
      children: [
        {
          id: PATH.TOOLS_ACTIVITY_LOGS,
          label: TITLES.TOOLS_ACTIVITY_LOGS,
          path: PATH.TOOLS_ACTIVITY_LOGS,
          allowed: true,
          icon: LogsIcon,
        },
        {
          id: PATH.TOOLS_BACKUPS,
          label: TITLES.TOOLS_BACKUPS,
          path: PATH.TOOLS_BACKUPS,
          allowed: true,
          icon: FileIcon,
        },
      ],
    },
    {
      id: 'fix-messages',
      icon: MessageCircleWarningIcon,
      label: 'Fix Messages',
      children: [
        {
          id: PATH.TOOLS_FAILED_FIX_MESSAGES,
          label: TITLES.TOOLS_FAILED_FIX_MESSAGES,
          path: PATH.TOOLS_FAILED_FIX_MESSAGES,
          allowed: true,
          icon: FileSearchIcon,
        },
        {
          id: PATH.TOOLS_FIX_AGGREGATION,
          label: TITLES.TOOLS_FIX_AGGREGATION,
          path: PATH.TOOLS_FIX_AGGREGATION,
          allowed: true,
          icon: BriefcaseConveyorBeltIcon,
        },
        {
          id: PATH.TOOLS_INSERT_FIX_MESSAGES,
          label: TITLES.TOOLS_INSERT_FIX_MESSAGES,
          path: PATH.TOOLS_INSERT_FIX_MESSAGES,
          allowed: true,
          icon: FilePlusIcon,
        },
      ],
    },
    {
      id: 'file-management',
      icon: FolderKanbanIcon,
      label: 'File Management',
      children: [
        {
          id: PATH.FILE_MANAGEMENT_FILES_MAPPING,
          label: TITLES.FILE_MANAGEMENT_FILES_MAPPING,
          path: PATH.FILE_MANAGEMENT_FILES_MAPPING,
          allowed: true,
          icon: FileIcon,
        },
        {
          id: PATH.FILE_MANAGEMENT_SFTP,
          label: TITLES.FILE_MANAGEMENT_SFTP,
          path: PATH.FILE_MANAGEMENT_SFTP,
          allowed: true,
          icon: FolderIcon,
        },
      ],
    },
    {
      id: 'system',
      icon: SettingsIcon,
      label: 'System',
      children: [
        {
          id: PATH.SYSTEM_CONSTANTS,
          label: TITLES.SYSTEM_CONSTANTS,
          path: PATH.SYSTEM_CONSTANTS,
          allowed: true,
          icon: ListCheckIcon,
        },
        {
          id: PATH.SYSTEM_MAINTENANCE,
          label: TITLES.SYSTEM_MAINTENANCE,
          path: PATH.SYSTEM_MAINTENANCE,
          allowed: true,
          icon: ConstructionIcon,
        },
      ],
    },
  ];
};
